import React from 'react'
import styled from '@emotion/styled'
import { WebLink, WebLinkProps } from 'common/navigation/web-link'
import { colors } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { StyledComponent } from '@emotion/styled'
import { Theme } from 'component-library/__styling/themes'
import { createPropFilter } from 'common/emotion'

export type PixelOffset = {
    // in %
    top: number
    // in %
    left: number
}
interface Props {
    baseColor: string
    iconScale?: number
    noBorder?: boolean
    offset?: PixelOffset
}

export const StyledIconButton = styled(WebLink, {
    shouldForwardProp: createPropFilter<WebLinkProps>()([
        'baseColor',
        'iconScale',
        'noBorder',
        'offset',
    ]),
})<Props>(
    ({ offset }) => ({
        display: 'inline-block',
        borderRadius: '50%',
        width: calcRem(34),
        height: calcRem(34),
        outline: 0,
        verticalAlign: 'middle',
        overflow: 'hidden',

        '& > svg': {
            display: 'block',
            position: 'relative',
            top: offset ? `${offset.top}%` : '50%',
            left: offset ? `${offset.left}%` : '50%',
            transform: 'translate(-50%, -50%)',
        },

        '& > svg path': {
            fill: 'white',
        },
    }),
    ({ iconScale }) => {
        const size = iconScale ? iconScale * 100 + '%' : '67%'
        return {
            '& > svg': {
                width: size,
                height: size,
            },
        }
    },
    ({ baseColor, noBorder }) => {
        return {
            background: baseColor,
            border: noBorder === true ? undefined : `2px solid ${baseColor}`,
        }
    },
    ({ theme }) => {
        return {
            ...conditionalStyles(theme.kind === 'perthnow', {
                '&:hover': {
                    borderColor: colors.perthnow.redRuby,
                    backgroundColor: colors.perthnow.redRuby,
                },
            }),
            ...conditionalStyles(theme.kind === 'thewest', {
                '&:hover': {
                    borderColor: theme.sectionValues.primaryColor,
                    backgroundColor: theme.sectionValues.primaryColor,
                },
            }),

            '&:focus': {
                border: `2px solid ${colors.darkGrey}`,
                background: 'transparent',
            },

            '&:focus > svg path': {
                fill: colors.darkGrey,
            },
        }
    }
)

// This is mainly for rss social buttons so the ssr is hit and not a csr
export const StyledIconButtonAnchorTag = StyledIconButton.withComponent('a') as StyledComponent<
    {
        theme?: Theme | undefined
    } & Props,
    React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
>
